import React, { useContext } from 'react';
import { NavLink } from 'react-router-dom';
import { Box, Button } from '@mui/material';

import DashboardIcon from '@mui/icons-material/Dashboard';
import AttachMoneyIcon from '@mui/icons-material/AttachMoney';
import HistoryIcon from '@mui/icons-material/History';
import PriceChangeIcon from '@mui/icons-material/PriceChange';
import PeopleIcon from '@mui/icons-material/People';
import PunchClockIcon from '@mui/icons-material/PunchClock';
import PersonIcon from '@mui/icons-material/Person';
import LogoutIcon from '@mui/icons-material/Logout';

import { AccessDataContext } from '../../contextProviders/AccessDataContext';
import { UserRoles } from '../../enums/UserRoles';

const NavMenu = () => {
  const { securityRoles, logoutUser } = useContext(AccessDataContext);
  return (
    <>
      <Box id="siteNav">
        <ul>
          <li>
            <NavLink to="/">
              <DashboardIcon />
              Dashboard
            </NavLink>
          </li>

          <li>
            <NavLink to="/pricelists">
              <AttachMoneyIcon />
              Pricelists
            </NavLink>
          </li>

          <li>
            <NavLink to="/online-results">
              <HistoryIcon />
              Online Results
            </NavLink>
          </li>

          {securityRoles && securityRoles?.length > 0 && securityRoles?.filter((f) => f === UserRoles.Admin).length > 0 ? (
            <>
              <li>
                <NavLink to="/master-pricelist">
                  <PriceChangeIcon />
                  Master Pricelist
                </NavLink>
              </li>
              <li>
                <NavLink to="/client-pricelists">
                  <PeopleIcon />
                  Client Pricelists
                </NavLink>
              </li>
            </>
          ) : null}

          {securityRoles && securityRoles?.length > 0 && securityRoles?.filter((f) => f === UserRoles.Staff).length > 0 ? (
            <li>
              <NavLink to="/staff-clocking">
                <PunchClockIcon />
                Staff Clocking
              </NavLink>
            </li>
          ) : null}
        </ul>
      </Box>

      <Box id="profileNav">
        <ul>
        {process.env.REACT_APP_SERVER_URL === "https://enviroapidev.envirolab.com.au" || process.env.REACT_APP_SERVER_URL === "https://localhost:44348" ?
            <li className='devEnv'>
              DEV ENVIRONMENT
            </li>: null}
          <li>
            <NavLink to="/profile">
              <PersonIcon />
              Profile
            </NavLink>
          </li>
          <li>
            <Button onClick={() => logoutUser()}>
              <LogoutIcon />
              Logout
            </Button>
          </li>
        </ul>
      </Box>
    </>
  );
};

export default NavMenu;
